import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUIModules } from '../redux/actions/uiModules';
import { StoreState } from '../types/state';

const useUIModules = () => {
  const uiModules = useSelector((state: StoreState) => {
    return state.clients.modules;
  });
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!uiModules) {
      dispatch(getUIModules());
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [uiModules, dispatch]);

  return { uiModules, isLoading };
};

export default useUIModules;
